import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, FilterMenuOptions, Project } from '../../models';
import { DashboardFilter } from '../../models/dashboard-filter';
import { Field } from '../logic-services/models';

/* istanbul ignore file */
@Injectable({
    providedIn: 'root'
})
export class DashboardsFilterDataService extends HttpBaseService {

    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    createDashboardsFilter(app: App, project: Project, dashboardFilter: DashboardFilter): Observable<DashboardFilter> {
        const url = `${this.route}${app.id}/projects/${project.id}/dashboards-filter`;
        return this.httpPost(url, dashboardFilter);
    }

    getDashboardsFilterByProjectId(app: App, project: Project): Observable<DashboardFilter> {
        const url = `${this.route}${app.id}/projects/${project.id}/dashboards-filter`;
        return this.httpGet(url);
    }

    //using a post in case there are many fields and the url limit is hit if they are sent as query params
    getDashboardFilterValuesByProjectId(currentApp: App, currentProject: Project, fieldsValuesToFetch: Field[]): Observable<FilterMenuOptions> {
        const url = `${this.route}${currentApp.id}/projects/${currentProject.id}/dashboards-filter/values`;
        const dataToSend = {
            fields: fieldsValuesToFetch
        };
        return this.httpPost(url, dataToSend);
    }

    updateDashboardsFilter(app: App, project: Project, dashboardFilter: DashboardFilter): Observable<DashboardFilter> {
        const url = `${this.route}${app.id}/projects/${project.id}/dashboards-filter/${dashboardFilter.id}`;
        return this.httpPut(url, dashboardFilter);
    }

    getDashboardsFilterMenuByProjectId(app: App, project: Project): Observable<FilterMenuOptions> {
        const url = `${this.route}${app.id}/projects/${project.id}/get-filter-menu`;
        return this.httpGet(url);
    }

    getSitesByFilterValues(app: App, project: Project, dashboardFilterMenuOptions: FilterMenuOptions): Observable<string[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/get-filtered-sites`;
        return this.httpPost(url, dashboardFilterMenuOptions);
    }

    getSummaryProjectDashboardsFilterMenu(app: App, project: Project): Observable<FilterMenuOptions> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/get-filter-menu`;
        return this.httpGet(url);
    }

    getSummaryProjectDashboardFilterValues(app: App, project: Project, fieldsValuesToFetch: Field[]): Observable<FilterMenuOptions> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/dashboards-filter/values`;
        const dataToSend = {
            fields: fieldsValuesToFetch
        };
        return this.httpPost(url, dataToSend);
    }

    getSummaryProjectSitesByFilterValues(app: App, project: Project, dashboardFilterMenuOptions: FilterMenuOptions): Observable<string[]> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/get-filtered-sites`;
        return this.httpPost(url, dashboardFilterMenuOptions);
    }
}
